// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__38_DD","label":"SetPasswdForm_label__2sjdf"};